import { render, staticRenderFns } from "./TextColumn.vue?vue&type=template&id=84291b56"
import script from "./TextColumn.vue?vue&type=script&lang=js"
export * from "./TextColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports